<template lang="pug">
  .about(v-if="about", style="")
    .about__border.about__border--top
    .about__border.about__border--right
    .about__border.about__border--bottom
    .about__border.about__border--left
    .about__corner.about__corner--tl
    .about__corner.about__corner--tr
    .about__corner.about__corner--bl
    .about__corner.about__corner--br
    .about__decor-top
    .about__decor-bottom
    .about__title(v-if="h1") {{h1}}
    .about__content
      .about__top(v-if="about.top")
        .about__top-photo-wr(v-if="about.top.quote.photo" :data-src="about.top.quote.photo")
          img.about__top-photo.about__top-photo--hide(:src="about.top.quote.photo")
        .about__top-slider(v-if="about.top.slides")
          .swiper-container
            .swiper-wrapper
              .swiper-slide(v-for="item in about.top.slides", :key="item.id", :data-src="item.src")
                img.about__top-slider-slide.about__top-slider-slide--hide(:src="item.src")
          .swiper-pagination
        .about__top-quote
          .about__top-quote-text {{about.top.quote.text}}
          img.about__top-quote-sign(:src="about.top.quote.sign")
      .about__bottom
        .about__bottom-text(v-html="about.bottom.text")
        .about__bottom-items(v-if="about.bottom.items")
          .about__bottom-item(v-for="item in about.bottom.items", :key="item.id")
            img.about__bottom-item-ico(:src="item.icon")
            |{{item.text}}


</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/about/about.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'About',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  data() {
    return {
      about: null,
      ps: null,
      swiper: null
    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadAboutPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    initSlider() {
      var slider = '.about__top-slider';

      if(this.swiper === null) {
        this.swiper = new Swiper($(slider).find('.swiper-container'), {
          direction: 'vertical',
          pagination: {
            el: $(slider).find('.swiper-pagination'),
            clickable: true,
          },
        });
      } else {
        this.swiper.update();
      }
    },

    request(url) {
      this.req('AboutPage:getAboutPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.about = res.content;
          this.$nextTick(() => {
            this.imgPreloader('about__top-photo-wr', 'about__top-photo', '', 250);
            this.imgPreloader('swiper-slide', 'about__top-slider-slide', '', 250);
            this.initSlider();
            this.initScroll();
          });
        }
      }, 'about');
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.about__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      }
      else {
        this.ps.update();
      }
    },
  }
}
</script>
